import { useRef } from 'react';
import { AiBlock } from '@/components/ai/AiBadge';
import { type CallEmotions } from './types';
import { EmotionTimeline } from './EmotionTimeline';
import { SpeakerProfileCard } from './SpeakerProfileCard';
import { CallWaveform, type WaveformHandle } from './CallWaveform';

/**
 * "תעודת הזהות הרגשית" של השיחה: פס קול חזותי + גרף רגשות כרונולוגי +
 * כרטיסי פרופיל לשני הדוברים + סיכום. הכל מסונכרן — לחיצה בגרף/ברגע מפתח
 * קופצת לזמן ב-waveform.
 */
export function EmotionPanel({ emotions, src, duration }: {
  emotions: CallEmotions; src?: string | null; duration?: number;
}) {
  const waveRef = useRef<WaveformHandle | null>(null);
  const seek = (t: number) => waveRef.current?.seekTo(t);
  const hasTimeline = (emotions.timeline?.length ?? 0) > 0;

  return (
    <AiBlock title="ניתוח רגשי">
      <div className="stack" style={{ gap: 10 }}>
        {emotions.overall?.summary && (
          <div style={{ fontSize: 'var(--t-sm)', color: 'var(--text)' }}>{emotions.overall.summary}</div>
        )}

        {src && <CallWaveform ref={waveRef} src={src} keyMoments={emotions.key_moments} duration={duration} />}

        {hasTimeline && <EmotionTimeline emotions={emotions} onSeek={seek} />}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 10 }}>
          <SpeakerProfileCard label="נציג" color="#2563eb" profile={emotions.speakers?.agent} />
          <SpeakerProfileCard label="לקוח" color="#16a34a" profile={emotions.speakers?.customer} />
        </div>

        {emotions.engine && (
          <div style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)', textAlign: 'end' }}>
            מנוע: {emotions.engine}
          </div>
        )}
      </div>
    </AiBlock>
  );
}
